document.addEventListener("DOMContentLoaded", () => {
	const backToTopButton = document.querySelector(
		".wp-block-webx-formica-back-to-top",
	);
	const track = backToTopButton?.querySelector(
		".webx-formica-back-to-top-track",
	);

	if (!backToTopButton || !track) {
		return;
	}

	const toggleVisibility = () => {
		const scrolled = window.scrollY;
		const isVisible = scrolled > 100;
		backToTopButton.classList.toggle("is-visible", isVisible);
	};

	const updateScrollProgress = () => {
		const scrollPosition = window.scrollY;
		const pageHeight =
			document.documentElement.scrollHeight - window.innerHeight;
		const scrollProgress = (scrollPosition / pageHeight) * 100;
		track.style.width = `${scrollProgress}%`;
	};

	const scrollToTop = (event) => {
		event.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	//toggleVisibility();
	//updateScrollProgress();

	window.addEventListener("scroll", () => {
		updateScrollProgress();
		if (window.scrollY > 150) {
			backToTopButton.classList.add("is-visible");
		} else {
			backToTopButton.classList.remove("is-visible");
		}
		//toggleVisibility();
	});

	backToTopButton.addEventListener("click", scrollToTop);
});
